<template>
  <div class="avatar-viewer">
    <img 
      :src="avatarUrl" 
      :alt="alt"
      :class="['avatar-image', sizeClass, shapeClass]"
      @click.stop="handleClick"
    />
    
    <!-- 图片预览对话框 -->
    <el-dialog 
      v-if="isPc"
      :visible.sync="dialogVisible"
      :show-close="true"
      :close-on-click-modal="true"
      :modal-append-to-body="true"
      append-to-body
      class="avatar-preview-dialog"
      width="50%"
      @close="dialogVisible = false"
    >
      <img :src="avatarUrl" :alt="alt" class="preview-image" />
    </el-dialog>
  </div>
</template>

<script>
import { ImagePreview } from 'vant'

export default {
  name: 'AvatarViewer',
  props: {
    src: {
      type: String,
      default: ''
    },
    alt: {
      type: String,
      default: '头像'
    },
    size: {
      type: String,
      default: 'medium',
      validator: (value) => ['small', 'medium', 'large', 'custom'].includes(value)
    },
    customSize: {
      type: String,
      default: '64px'
    },
    shape: {
      type: String,
      default: 'circle',
      validator: (value) => ['circle', 'square'].includes(value)
    },
    defaultAvatar: {
      type: String,
      default: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
    }
  },
  data() {
    return {
      dialogVisible: false,
      isPc: true
    }
  },
  computed: {
    avatarUrl() {
      return this.src || this.defaultAvatar
    },
    sizeClass() {
      if (this.size === 'custom') {
        return 'custom-size'
      }
      return `avatar-${this.size}`
    },
    shapeClass() {
      return `avatar-${this.shape}`
    }
  },
  mounted() {
    this.isPc = this.$deviceType === 'pc' || window.innerWidth > 768
  },
  methods: {
    handleClick() {
      if (this.avatarUrl) {
        if (this.isPc) {
          this.dialogVisible = true
        } else {
          this.openMobilePreview()
        }
        this.$emit('click', this.avatarUrl)
      }
    },
    openMobilePreview() {
      ImagePreview({
        images: [this.avatarUrl],
        showIndex: false,
        closeable: true,
        onClose: () => {
          this.$emit('close')
        }
      })
    }
  }
}
</script>

<style scoped>
.avatar-viewer {
  display: inline-block;
  cursor: pointer;
  transition: transform 0.2s;
}

.avatar-viewer:hover {
  transform: scale(1.05);
}

.avatar-image {
  object-fit: cover;
  transition: all 0.3s;
}

.avatar-image:hover {
  opacity: 0.9;
}

/* 尺寸 */
.avatar-small {
  width: 32px;
  height: 32px;
}

.avatar-medium {
  width: 64px;
  height: 64px;
}

.avatar-large {
  width: 100px;
  height: 100px;
}

.custom-size {
  width: v-bind(customSize);
  height: v-bind(customSize);
}

/* 形状 */
.avatar-circle {
  border-radius: 50%;
}

.avatar-square {
  border-radius: 4px;
}

/* PC 端预览对话框 */
.avatar-preview-dialog ::v-deep .el-dialog__body {
  /* padding: 0; */
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;
  /* background-color: rgba(0, 0, 0, 0.8); */
}

.avatar-preview-dialog ::v-deep .el-dialog {
  /* background: transparent; */
  /* box-shadow: none; */
}

.preview-image {
  max-width: 90vw;
  max-height: 90vh;
  border-radius: 4px;
}
</style>
